// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Tab from '../../../shared/state/tab';
import TabNavigation from '../../../shared/components/tab-navigation';

const PartRequestHeader = props => {

    const navigationTabs = [
        new Tab({
            count: props.openPartRequestsCount,
            label: 'OPEN_PART_REQUESTS_WITH_COUNT',
            route: '/part-requests/open'
        }),
        new Tab({
            count: props.allPartRequestsCount,
            label: 'ALL_PART_REQUESTS_WITH_COUNT',
            route: '/part-requests/all'
        })
    ];

    if (props.hasSearchResultsLoaded) {

        navigationTabs.push(new Tab({
            count: props.searchResultsCount,
            label: 'SEARCH_RESULTS_TAB',
            route: '/part-requests/search'
        }));

    }

    return (
        <header className='part-returns-header'>
            <TabNavigation tabs={navigationTabs}/>
        </header>
    );

};

PartRequestHeader.displayName = 'PartRequestHeader';
PartRequestHeader.propTypes = {
    allPartRequestsCount: PropTypes.number,
    hasSearchResultsLoaded: PropTypes.bool,
    openPartRequestsCount: PropTypes.number,
    searchResultsCount: PropTypes.number
};

export default PartRequestHeader;



// WEBPACK FOOTER //
// ./src/part-requests/shared/components/part-request-header.js